<template>
  <div style="background: #000;">
    <spinner></spinner>
    <v-login></v-login>
    <v-suspended></v-suspended>
    <q-layout :view="layout" :class="textAlign" style="background: #000;">

      <!-- Navbar -->
      <q-layout-header v-if="$route.name !=='games.preview'" :reveal="!this.$breakpoints.isGreaterThan('sm')">
        <v-header @rightDrawerToogle="right = !right"></v-header>
      </q-layout-header>

      <!-- Right Side Panel -->
      <q-layout-drawer :side="position" v-model="right" behavior="mobile" v-if="!this.$breakpoints.isGreaterThan('sm')">
        <v-menu></v-menu>
      </q-layout-drawer>

      <!-- Content -->
      <q-page-container>
        <router-view/>
      </q-page-container>

      <!-- Footer -->
      <q-layout-footer v-if="$route.name !=='games.preview'" :reveal="!this.$breakpoints.isGreaterThan('sm')">
        <v-footer></v-footer>
      </q-layout-footer>

    </q-layout>
  </div>
</template>

<script>
import VHeader from '../components/Header'
import VMenu from '../components/Menu'
import VFooter from '../components/Footer'
import VLogin from '../pages/auth/login'
import {mapGetters} from 'vuex'

import {
  QLayout,
  QLayoutHeader,
  QLayoutDrawer,
  QLayoutFooter,
  QPageContainer
} from 'quasar-framework'
import VSuspended from "../pages/auth/suspended";

export default {
  name: 'MainLayout',

  components: {
    VSuspended,
    VHeader,
    VMenu,
    VFooter,
    VLogin,
    QLayout,
    QLayoutHeader,
    QLayoutDrawer,
    QLayoutFooter,
    QPageContainer
  },

  data() {
    return {
      right: false,
      textAlign: '',
      position: '',
    }
  },
  mounted() {
    this.setLang()
  },

  computed: {
    ...mapGetters({
      locale: 'lang/locale',
      locales: 'lang/locales',
      user: 'auth/user'
    }),
    layout() {
      if (this.$breakpoints.isGreaterThan('sm'))
        return 'lhr lpr lfr'
      return 'lHr lpr lFr'
    }
  },
  methods: {
    setLang(){
      if (this.locale === 'ar'){
        this.textAlign = 'text-right'
        this.position = 'right left'
      }else{
        this.position = 'right'
        this.textAlign = 'text-left'
      }
    }
  }
}
</script>

<style>
.color-app {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue